module.exports = __webpack_public_path__ + "static/img/lixiaojia.62f13b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/lixiaojia.png
// module id = 687H
// module chunks = 0